import { acceptHMRUpdate, defineStore } from 'pinia'

export const useAppStore = defineStore('app', {
  state: () => ({
    previousRoute: null,
    isInitialized: false,
    isContentfulInitialized: false,
    isLoaderVisible: false,
    newsletterMail: '',
    isFooterQuoteVisible: true,
    isEmergencyPopupVisible: true,
    isBackToTopBtnVisible: false,
    criticalViewData: null,
    notAuthorizedErrors: [],
    headerSearchQuery: '',
    isContentfulPreview: false,
  }),

  actions: {
    setPreviousRoute(route) {
      this.previousRoute = {
        query: route.query,
        params: route.params,
        name: route.name,
        hash: route.hash,
        meta: route.meta,
        fullPath: route.fullPath,
      }
    },

    setInitialized(value) {
      this.isInitialized = value
    },

    setContentfulInitialized(value) {
      this.isContentfulInitialized = value
    },

    setNewsletterMail(value) {
      this.newsletterMail = value
    },

    toggleLoader(value) {
      this.isLoaderVisible = value
    },

    toggleFooterQuote(isFooterQuoteVisible) {
      this.isFooterQuoteVisible = isFooterQuoteVisible
    },

    toggleEmergencyPopup(isEmergencyPopupVisible) {
      this.isEmergencyPopupVisible = isEmergencyPopupVisible
    },

    toggleBackToTopBtn(isBackToTopBtnVisible) {
      this.isBackToTopBtnVisible = isBackToTopBtnVisible
    },

    setCriticalViewData(data) {
      this.criticalViewData = data
    },

    setNotAuthorizedErrors(errors) {
      this.notAuthorizedErrors = errors
    },

    setHeaderSearchQuery(query = '') {
      this.headerSearchQuery = query
    },

    setIsContentfulPreview(isContentfulPreview) {
      this.isContentfulPreview = isContentfulPreview
    },
  },

  persist: {
    pick: ['isFooterQuoteVisible', 'isEmergencyPopupVisible'],
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAppStore, import.meta.hot))
}
